import { ApiHelper } from 'utils/apiHelper';

import { Environment } from 'Environment';
import * as ServiceTypes from 'reactApp/modules/ServiceModule/ServiceModule.types';

export const ServiceApi = {
    loadServices(pid: string) {
        return ApiHelper.rpcCall<ServiceTypes.ServicesApiResponse>({
            url: `/api/v1/projects/${pid}/services`,
        });
    },

    activateServices(pid) {
        return ApiHelper.rpcCall<ServiceTypes.ServicesApiResponse>({
            url: `/api/v1/projects/${pid}/services`,
            method: 'POST',
            data: { metrics: Environment.utmParams },
        });
    },

    activateService(pid, serviceName: ServiceTypes.ApiServiceName) {
        return ApiHelper.rpcCall<ServiceTypes.ServiceData>({
            url: `/api/v1/projects/${pid}/services/${serviceName}`,
            method: 'POST',
            data: { metrics: Environment.utmParams },
        });
    },

    notifyWhenServiceReleased(pid: string, serviceName: string) {
        return ApiHelper.rpcCall({
            url: `/api/v1/projects/${pid}/services/smartsound/launch_message`,
            method: 'POST',
            data: { service: serviceName },
        });
    },
};
